import { useEffect, ReactNode, PropsWithChildren } from 'react';
import { sendEvent } from '../api/nativeBridge';
import { useTokenStore } from '../hooks/useStore.ts';

interface TokenCheckProps {
  loadingComponent: ReactNode;
}

const TokenCheck = ({
  loadingComponent,
  children,
}: PropsWithChildren<TokenCheckProps>) => {
  const { token, setToken } = useTokenStore((state) => state);

  useEffect(() => {
    sendEvent('GET_TOKEN');
    sendEvent('GET_CONFIG');

    const ENV_MODE = import.meta.env.MODE; // Vite에서 mode 확인
    if (ENV_MODE === 'development') {
      const params = new URLSearchParams(window.location.search);
      const queryToken = params.get('t');
      if (queryToken) {
        setToken(queryToken);
      }
    }
  }, []);

  return token === null ? loadingComponent : children;
};

export default TokenCheck;
